module.exports = __webpack_public_path__ + "static/media/cc.8e11fb01.svg";